export default __webpack_public_path__ + "static/media/dark_download_icon.1fed62ce.svg";